import React from 'react';
import { Star, Sparkles, Zap, MousePointerClick, Headphones, Clock } from 'lucide-react';
import { IMAGES } from '../i18n';

const ICONS = [Star, Sparkles, Zap, MousePointerClick, Headphones, Clock];

const Benefits = ({ t }) => {
  return (
    <section id="section-4" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-ink mb-4">{t.title}</h2>
          <p className="text-lg sm:text-xl text-slate-600 max-w-3xl mx-auto">{t.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.items.map((benefit, index) => {
            const Icon = ICONS[index];
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-ink mb-4">{benefit.title}</h3>
                <p className="text-slate-600 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="relative inline-block max-w-lg w-full">
            <img
              src={IMAGES.benefits}
              alt={t.imageAlt}
              className="w-full rounded-2xl shadow-2xl object-cover max-h-[420px]"
              loading="lazy"
            />
            <div className="absolute -top-4 -left-2 sm:-left-4 bg-accent text-white px-4 sm:px-6 py-2 sm:py-3 rounded-full text-sm sm:text-lg font-semibold shadow-lg">
              {t.badge}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
